import axios from "axios";
import store from "../store/index";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error.response?.data);
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data.error === "Token no valido"
    ) {
      store.dispatch("salir");
    }
    return Promise.reject(error);
  }
);

export default axios;
